import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    perm: '',
    routes: [],
    needMsg: Boolean, // 是否需要提示token过期
    stopMsg: Boolean, // 是否需要提示用户已停用
    uploadList: [], // 待上传列表
    uploadingPnList: {}, // 正在上传的产品{pn: uid}
    failedPnList: {} // 已取消或者上传失败的产品{pn: uid}
  },
  mutations: { // 同步
    updateUserName(state, name) {
      state.username = name
    },
    updatePerm(state, name) {
      state.perm = name
    },
    initRoutes(state, data) {
      state.routes = data
    },
    clearRoutes(state) {
      state.routes = []
    },
    changeNeedMsg(state, data) {
      state.needMsg = data
    },
    changeStopMsg(state, data) {
      state.stopMsg = data
    },
    // 增加上传
    addUpload(state, data) {
      state.uploadList.push(data)
    },
    // 清空上传
    clearUpload(state) {
      state.uploadList = []
    },
    // 更新正在上传的产品
    updateUploadingPnList(state, data) {
      state.uploadingPnList = data
    },
    // 更新已取消或者上传失败的产品
    updateFailedPnList(state, data) {
      state.failedPnList = data
    }
  },
  actions: { // 异步
  },
  modules: {
  }
})
